import axios from 'axios';
import { receiveApiError } from './errors';
import { getOrder } from './order';
import Orders from '../services/Orders';
import createSubscribeAction from '../helpers/createSubscribeAction';

const { CancelToken } = axios;

export const LOADING_ORDERS = 'LOADING_ORDERS';
export const RECEIVE_ORDERS = 'RECEIVE_ORDERS';
export const SEARCH_ORDERS = 'SEARCH_ORDERS';
export const SEARCH_ORDERS_STATUS = 'SEARCH_ORDERS_STATUS';
export const SEARCH_ORDERS_HOURS = 'SEARCH_ORDERS_HOURS';
export const ERROR_ORDERS = 'ERROR_ORDERS';

export function loadingOrders() {
  return {
    type: LOADING_ORDERS,
  };
}

export function receiveOrders(orders) {
  return {
    type: RECEIVE_ORDERS,
    orders,
  };
}

export function searchOrdersByStatus(status) {
  return {
    type: SEARCH_ORDERS_STATUS,
    status,
  };
}

export function searchOrdersByHours(hours) {
  return {
    type: SEARCH_ORDERS_HOURS,
    hours,
  };
}

export function searchOrders(search) {
  return {
    type: SEARCH_ORDERS,
    search,
  };
}

export function errorOrders(payload) {
  return {
    type: ERROR_ORDERS,
    payload,
  };
}

export function getOrders(hours, cancelToken) {
  return dispatch => {
    dispatch(loadingOrders());

    return Orders.get(hours, cancelToken)
      .then(resp => {
        dispatch(receiveOrders(resp.data));
        if (resp.data.length) {
          dispatch(getOrder(resp.data[0].id));
        }
      })
      .catch(() => {
        dispatch(errorOrders('Erro ao buscar pedidos'));
      });
  };
}

export const START_SUBSCRIBE_ORDERS = 'START_SUBSCRIBE_ORDERS';
export const CANCEL_SUBSCRIBE_ORDERS = 'CANCEL_SUBSCRIBE_ORDERS';

export function startSubscribeOrders(id) {
  return {
    type: START_SUBSCRIBE_ORDERS,
    id,
  };
}

export function cancelSubscribeOrders(id) {
  return {
    type: CANCEL_SUBSCRIBE_ORDERS,
    id,
  };
}

/**
 * @param status
 * @param hours
 * @param type
 * @param interval seconds
 * @returns {function(*=): Function}
 */
export const subscribeOrdersByStatus = (status, hours, type = {}, interval) => {
  return createSubscribeAction((dispatch, id) => {
    dispatch(startSubscribeOrders(id));
    dispatch(loadingOrders());
    let lastResponse;
    let source;
    return {
      async call() {
        source = CancelToken.source();
        try {
          const { data, request } = await Orders.getByStatus(
            status.id,
            hours.value,
            type.value,
            source.token
          );
          if (request.response !== lastResponse) {
            lastResponse = request.response;
            dispatch(receiveOrders(data));
          }
        } catch (error) {
          if (error.message !== 'unsubscribed') {
            dispatch(errorOrders('Erro ao buscar pedidos'));
          }
        }
      },
      cancel() {
        if (source) {
          source.cancel('unsubscribed');
        }
      },
    };
  }, interval);
};

export function getOrdersByStatusNotLoading(status) {
  return dispatch => {
    dispatch(searchOrdersByStatus(status));
    return Orders.getByStatus(status.id)
      .then(resp => {
        dispatch(receiveOrders(resp.data));
      })
      .catch(() => {
        dispatch(receiveApiError('Erro ao buscar pedidos'));
      });
  };
}

export function getOrdersByStatus(status, hours, type = {}, cancelToken) {
  return (dispatch, getState) => {
    dispatch(loadingOrders());
    dispatch(searchOrdersByStatus(status));
    dispatch(searchOrdersByHours(hours));
    return Orders.getByStatus(status.id, hours.value, type.value, cancelToken)
      .then(({ data, request }) => {
        dispatch(receiveOrders(data));
        return data;
      })
      .catch(() => {
        dispatch(errorOrders('Erro ao buscar pedidos'));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/orders.js